import {
  useCustomAuth as useCustomAuthContext,
  CustomAuthUser,
} from 'modules/auth/contexts/CustomAuthContext';

// This hook provides the same interface as the existing useAuth hook
// but uses our custom authentication system instead of Cognito/Auth0
export const useCustomAuth = () => {
  const customAuth = useCustomAuthContext();

  // Transform the custom auth interface to match the existing useAuth interface
  const getAccessTokenSilently = async (): Promise<string | null> =>
    customAuth.getAccessToken();

  const getUserAuthData = (user: CustomAuthUser): CustomAuthUser => user;

  const login = async (): Promise<void> => {
    // This method is not used in the custom auth flow
    // The login is handled by the CustomLoginForm component
    throw new Error('Login should be handled by the CustomLoginForm component');
  };

  return {
    isAuthenticated: customAuth.isAuthenticated,
    user: customAuth.user,
    loading: customAuth.isLoading,
    login,
    logout: customAuth.logout,
    getAccessTokenSilently,
    getAccessToken: customAuth.getAccessToken,
    getUserAuthData,
    provider: 'custom' as const,
    error: customAuth.error,
    clearError: customAuth.clearError,
    refreshAuth: customAuth.refreshAuth,
  };
};
